<script>/* eslint-disable */</script>
<template>
  <div style="height:400px" ref="AverageAgingLineChart"></div>
</template>

<script>

import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import animated from "@amcharts/amcharts4/themes/animated.js";

import moment from 'moment'

am4core.useTheme(animated);

export default {
  data(){
    return {
      chart: null,
      valueAxis : null
    }
  },
  mounted(){
    this.createChart();
    this.loadData()
  },
  beforeDestroy(){
    this.chart.dispose()
  },
  props: ['mdData' , 'dData', 'endData', 'type', 'week'],
  watch : {
    type: function() {
      this.loadData()
    },
    week : {
      deep : true,
      handler : function () {
        this.loadData()
      }
    }
  },
  methods: {
    loadData () {

      this.chart.dispose()

      this.createChart()
      let length = this.chart.data.length

      let data = JSON.parse(JSON.stringify(this.type == 'MD' ? this.mdData : this.type == 'D' ? this.dData : this.endData))
      // console.log(data)
      let startSlice = 0
      let endSlice = 0

      if (this.week > 3) {
          startSlice = 7 * (this.week - 1)
          endSlice = startSlice + (data.length - startSlice)
      }
      else {
          startSlice = 7 * (this.week - 1)
          endSlice = startSlice + 7
      }
      
      data = data.slice(startSlice , endSlice)
      // console.log(data)
      let series = this.chart.series.push(new am4charts.ColumnSeries())
      series.dataFields.valueY = 'total'
      series.dataFields.dateX = 'date'
      series.name = 'Total Stock'
      series.yAxis = this.valueAxis2
      series.tooltipText = `{name} {dateX}: [bold]{valueY}[/]`;

      
    
      //DATA PROCESSING STARTS

      let keys = Object.keys(data[0] ? data[0] : {})
      for(var i = 0 ; i < keys.length ; i++) {
        if(keys[i] == 'date' || keys[i] == 'total')
          continue

        this.createAxisAndSeries(keys[i], keys[i] + ' Stock Days', false, i % 3);
      }

      this.chart.addData(data, length)
      
    },
    createChart () {
      this.chart = am4core.create(this.$refs.AverageAgingLineChart, am4charts.XYChart);
      
      // this.chart.colors.step = 4;

      // Create axes
    //   let dateAxis = this.chart.xAxes.push(new am4charts.DateAxis());
    //   dateAxis.renderer.minGridDistance = 50;
    //   dateAxis.title.text = "Stock Days"
      let dateAxis = this.chart.xAxes.push(new am4charts.DateAxis())
      dateAxis.title.text = "Date"

      this.chart.colors.list = [
        am4core.color("#FFC75F"),
        am4core.color("#D65DB1"),
        am4core.color("#FF6F91"),
        am4core.color("#FCBA12"),
        am4core.color('#808000'),
        am4core.color('#00FFFF')
      ];

      // Create series
      this.valueAxis = this.chart.yAxes.push(new am4charts.ValueAxis());
      this.valueAxis.title.text = "No. of Stock Days (Line Chart)"
      this.valueAxis.min = 0;

      this.valueAxis2 = this.chart.yAxes.push(new am4charts.ValueAxis());
      this.valueAxis2.title.text = "No. of Stock (Bar Chart)"
      this.valueAxis2.min = 0;
      this.valueAxis2.renderer.opposite = true;

      // Add legend
      this.chart.legend = new am4charts.Legend();

      

      this.chart.exporting.menu = new am4core.ExportMenu();

      // Add cursor
      this.chart.cursor = new am4charts.XYCursor();
    },
    createAxisAndSeries(field, name, opposite, bullet) {
      // console.log(field)
        
        let series = this.chart.series.push(new am4charts.LineSeries());
        series.dataFields.valueY = field;
        series.dataFields.dateX = "date";
        series.strokeWidth = 2;
        series.name = name;
        series.yAxis = this.valueAxis
        series.tooltipText = "{name}: [bold]{valueY}[/]";
        series.tensionX = 0.8;
        series.showOnInit = true;
        
        let interfaceColors = new am4core.InterfaceColorSet();
        
        switch(bullet) {
          case 0:
            let bullet = series.bullets.push(new am4charts.Bullet());
            bullet.width = 12;
            bullet.height = 12;
            bullet.horizontalCenter = "middle";
            bullet.verticalCenter = "middle";
            
            let triangle = bullet.createChild(am4core.Triangle);
            triangle.stroke = interfaceColors.getFor("background");
            triangle.strokeWidth = 2;
            triangle.direction = "top";
            triangle.width = 12;
            triangle.height = 12;
            break;
          case 1:
            let bullet1 = series.bullets.push(new am4charts.Bullet());
            bullet1.width = 10;
            bullet1.height = 10;
            bullet1.horizontalCenter = "middle";
            bullet1.verticalCenter = "middle";
            
            let rectangle = bullet1.createChild(am4core.Rectangle);
            rectangle.stroke = interfaceColors.getFor("background");
            rectangle.strokeWidth = 2;
            rectangle.width = 10;
            rectangle.height = 10;
            break;
          default:
            let bullet2 = series.bullets.push(new am4charts.CircleBullet());
            bullet2.circle.stroke = interfaceColors.getFor("background");
            bullet2.circle.strokeWidth = 2;
            break;
        }
        
        this.valueAxis.renderer.line.strokeOpacity = 1;
        this.valueAxis.renderer.line.strokeWidth = 2;
        this.valueAxis.renderer.line.stroke = series.stroke;
        this.valueAxis.renderer.labels.template.fill = series.stroke;
        this.valueAxis.renderer.opposite = opposite;
      }
  }
}
</script>